<template id="boton-proceso-tab-captura">
  <div>
    <div class="btn-proceso">
      <v-layout
        class="botones-colores"
        align-center
        justify-center
        fill-height
        wrap
      >
        <v-flex
          xs2
          v-for="(btn, index) in lstBtn"
          :key="index"
          @click="activateBtn(btn)"
        >
          <v-flex botones>
            <mini-statistic
              :icon="btn.icon"
              :title="btn.title"
              :sub-title="btn.subtitle"
              :color="btn.color"
              :class="btn.class"
              :value="true"
            ></mini-statistic>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="tab-captura">
      <recepcion-sub-tab
        v-if="subPro == 'RECEPCION'"
        :show="true"
        :tipeView="'modifica'"
      ></recepcion-sub-tab>
      <seguimiento-sub-tab
        v-if="subPro == 'SEGUIMIENTO'"
        :show="true"
        :tipeView="'modifica'"
      ></seguimiento-sub-tab>
      <cuadratura-sub-tab
        v-if="subPro == 'CUADRATURA'"
        :show="true"
        :tipeView="'modifica'"
      ></cuadratura-sub-tab>
      <destruccion-sub-tab
        v-if="tab == 'Destruccion'"
        :show="true"
        :tipeView="'modifica'"
      ></destruccion-sub-tab>
      <administracion-sub-tab
        v-if="tab == 'Administrativo'"
        :show="true"
        :tipeView="'modifica'"
      ></administracion-sub-tab>
      <reportes-sub-tab
        v-if="subPro == 'REPORTES' && proSelectedStored == 'CAPTURA'"
        :show="true"
        :tipeView="'modifica'"
      ></reportes-sub-tab>
    </div>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import RecepcionSubTab from "@/modules/captura/views/recepcion/RecepcionSubTab.vue";
import SeguimientoSubTab from "@/modules/captura/views/seguimiento/SeguimientoSubTab.vue";
import CuadraturaSubTab from "@/modules/captura/views/cuadratura/CuadraturaSubTab_new.vue"; //dsoto 17/01/2023
import DestruccionSubTab from "@/modules/captura/views/destruccion/DestruccionSubTab.vue";
import AdministracionSubTab from "@/modules/adminDocs/views/AdministracionSubTab.vue";
import ReportesSubTab from "@/modules/prodReport/views/ReportesSubTab.vue";

export default {
  name: "boton-proceso-tab-captura",
  props: {
    lstBtn: "",
  },
  data() {
    return {
      tab: "Recepcion",
      subPro: "RECEPCION",
    };
  },
  components: {
    MiniStatistic,
    RecepcionSubTab,
    SeguimientoSubTab,
    CuadraturaSubTab,
    DestruccionSubTab,
    AdministracionSubTab,
    ReportesSubTab,
  },
  created() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proSelectedStored = this.$store.getters.proSelectedStored;
  },

  watch: {
    lstBtn(val) {
      if (this.subPro != "") {
        let btnSeleccionado = this.lstBtn.filter((d) =>
          this.subPro
            .split(" ")
            .every((v) => d.title.toLowerCase().includes(v.toLowerCase()))
        );
        if (btnSeleccionado.length > 0) {
          if (this.subPro.toLowerCase() == "prod") {
            btnSeleccionado[0].class = "activo rombo reportes";
          } else {
            btnSeleccionado[0].class =
              "activo rombo " + this.subPro.toLowerCase();
          }
        } else {
          //console.log("else:" + btnSeleccionado.length + ":");
          this.lstBtn.forEach((b) => {
            //console.log(":" + b.subPro + ":");
            if (b.subPro == this.subPro) {
              //console.log("activa:" + b.subPro + ":");
              if (b.subPro == "prod") {
                b.class = "activo rombo reportes";
              } else {
                b.class = "activo rombo " + this.subPro.toLowerCase();
              }
            }
          });
        }
      }
    },
  },

  methods: {
    activateBtn(btn) {
      this.tab = btn.tab;
      this.subPro = btn.subPro;
      this.$store.commit("sub_tab_state", this.tab);
      this.$store.commit("sub_pro_tab_state", this.subPro);

      this.lstBtn.forEach((b) => {
        if (b.title != btn.title) {
          //desactiva b: quita "activo" y agrega  elevation-10
          b.class = b.class.replaceAll("activo", "");
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " elevation-10";
          //console.log("desactiva:" + b.title + ":" + b.class + "::");
        } else {
          //activa b:agrega activo, quita  elevation-10
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " activo";
          // console.log("activa:" + b.title + ":" + b.class + "::");
        }
      });
    },
  },
};
</script>
